import { NgOptimizedImage } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';  // <-- Import here
import { ApiService } from '../../utilities/api.service';
import { ToastComponent } from '../toast/toast.component';
import { RouterModule } from '@angular/router';
import { InputMaskDirective } from '../../directives/inputMask.directive';
import { ModalService } from '../../services/modal.service';
import { CongratulationPopupComponent } from '../congratulation-popup/congratulation-popup.component';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-footer',
    imports: [NgOptimizedImage, ReactiveFormsModule, ToastComponent, RouterModule, InputMaskDirective,
        CongratulationPopupComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
})

export class FooterComponent {
    touchWithUs: FormGroup;
    message: any;
    showToastSuccess: boolean = false;
    showToastFailure: boolean = false;
    constructor(private formBuilder: FormBuilder, private el: ElementRef, private _apiService: ApiService,
        private modalService: ModalService, private cdr: ChangeDetectorRef) {
        this.touchWithUs = this.formBuilder.group({
            email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]{2,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')]],
        })
    }

    onSubmit() {
        this.touchWithUs.markAllAsTouched();
        if (this.touchWithUs.invalid) {
            for (const key of Object.keys(this.touchWithUs.controls)) {
                if (this.touchWithUs.controls[key].invalid) {
                    const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                    invalidControl.focus();
                    break;
                }
            }
            return;
        } else {
            this.submitData();
        }
    }

    async submitData() {
        let getValue = this.touchWithUs.value;
        const data = {
            "module": "EmailSubscripe",
            "action": "emailSubscription",
            "data": {
                "email": getValue.email
            }
        };
        let response = await this._apiService.postApiDataWithEvents("productData/services", data);
        let checkIsSuccess = response.success || false;
        if (checkIsSuccess) {
            this.message = response.data.message || "The submission was successful."
            this.showToastSuccess = true;
            this.showToastFailure = false;
            this.modalService.showModal("congrts");
            this.touchWithUs.patchValue({
                "email": ""
            });
            setTimeout(() => {
                this.touchWithUs.markAsUntouched()
            }, 1000);
        } else {
            this.message = response.status.data.message || "OOPS!, Something went Wrong !"
            this.showToastSuccess = false;
            this.showToastFailure = true;
        }


    }
    assetsCDNUrl = environment.assetsCDNUrl;
    linkData = [
        {
            name: 'About us',
            title: 'About us',
            url: 'about-us',

        },
        {
            name: 'Solutions',
            title: 'Solutions',
            url: 'solutions'
        },
        {
            name: 'Insights',
            title: 'Insights',
            url: 'insights'
        },
        {
            name: 'Media Corner',
            title: 'Media Corner',
            url: 'media-corner'
        },
        {
            name: 'Contact Us',
            title: 'Contact Us',
            url: 'contact-us'
        },
        {
            name: 'Privacy Policy',
            title: 'Privacy Policy',
            url: 'assets/pdf/privacy-policy.pdf',
            blank: true
        },
        {
            name: 'Disclosures,<br/>Terms & Conditions',
            title: 'Disclosures, Terms & Conditions',
            url: '/assets/terms-and-condition.pdf',
            blank: true
        },
        {
            name: 'Customer Onboarding Terms & Conditions',
            title: 'Customer Onboarding Terms & Conditions',
            url: '/assets/pdf/declaration-and-undertaking.pdf',
            blank: true
        },



    ]
    socialMedia = [
        {
            title: 'Facebook',
            imgUrl: '/assets/images/icons/fb.svg',
            url: 'https://www.facebook.com/profile.php?id=61570845327379'
        },
        {
            title: 'x',
            imgUrl: '/assets/images/icons/x.svg',
            url: 'https://x.com/ShriramWealth01'
        },
        {
            title: 'linkedin',
            imgUrl: '/assets/images/icons/linked.svg',
            url: 'https://www.linkedin.com/company/shriram-wealth/about/'
        },
        {
            title: 'instagram',
            imgUrl: '/assets/images/icons/instagram.svg',
            url: 'https://www.instagram.com/shriram.wealth/'
        }
    ]
}